import { gql } from 'graphql-tag'
// import preview from '../../../config/preview'
import { fragmentModuleNavigationLink, fragmentModuleMedia } from '../../../core/data-layer/modules/fragments'
import queryPageFields from '../../../core/data-layer/pages/page/query-page-fields'
import queryNews from '../../../core/data-layer/news/query-news'
// NOTE: queryNews is using fragmentModuleMedia

export default gql`
  ${fragmentModuleNavigationLink}
  ${fragmentModuleMedia}
  query($slug: String!, $locale: String!, $date: DateTime!) {
    page: pagePressAndMediaNewsroomCollection(limit: 1, where: { slug: $slug }, locale: $locale) {
      items {
        ${queryPageFields}
        headerPrimaryLink {
          ...ModuleNavigationLinkFragment
        }
        headerSecondaryLink {
          ...ModuleNavigationLinkFragment
        }
        filtersRegionPlaceholder
        filtersCategoryPlaceholder
        filtersYearPlaceholder
        noResultsFound
        categoryCommercial
        categoryInvestorRelations
      }
    }
    news: pagePressAndMediaDetailCollection(where: { slug_exists: true, hiddenInHomePage_not: true, date_gt: $date  }, order: date_DESC, limit: 50, locale: $locale) {
      items {
        ...${queryNews}
      }
    }
  }
`
